import { useState } from 'react';
import { KTCard } from '../../../../_metronic/helpers';
import { ToastTopLeft } from '../../components/ToastTopLeft';
import { ThemeEditModal } from './themes-edit-modal/ui/ThemeEditModal';
import { ThemeModalState } from './themes-grid/model/types';
import { ThemesGrid } from './themes-grid/ui/ThemesGrid';

export const ThemesPage = () => {
	const [openModal, setOpenModal] = useState<ThemeModalState | null>(null);
	const [showErrorToast, setShowErrorToast] = useState(false);

	const handleModalClose = () => {
		setOpenModal(null);
	};

	return (
		<KTCard className='w-100'>
			<ThemesGrid setOpenModal={setOpenModal} />

			{openModal && (
				<ThemeEditModal
					openModal={openModal}
					handleModalClose={handleModalClose}
					setShowErrorToast={setShowErrorToast}
				/>
			)}

			<ToastTopLeft
				showToast={showErrorToast}
				setShowToast={setShowErrorToast}
				state='danger'
			/>
		</KTCard>
	);
};
